<template>
  <div class="container">
    <div class="columns is-centered">
      <div
        class="column is-12-mobile is-10-tablet is-10-desktop is-10-widescreen"
      >
        <router-view v-on:childinit="onChildInit" />
        <credit />

        <div class="nav-bottom">
          <ul>
            <li>
              <a href="/login" :class="getActiveClass('login')">
                <i class="fas fa-home"></i>{{ $t('bottomMenu.home') }}
              </a>
            </li>
            <li>
              <a href="/register" :class="getActiveClass('register')">
                <i class="fas fa-user"></i>{{ $t('bottomMenu.register') }}
              </a>
            </li>
            <!-- <li>
              <a href="/howto" :class="getActiveClass('howto')">
                <i class="fas fa-question-circle"></i>
                {{ $t('bottomMenu.howTo') }}
              </a>
            </li> -->
            <li>
              <a href="/contact" :class="getActiveClass('contact')">
                <i class="fab fa-line"></i>{{ $t('bottomMenu.contact') }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getToken, removeToken } from '@/utils/auth'
import Credit from '@/components/Credit'

export default {
  name: 'BottomMenu',
  components: {
    Credit
  },
  data() {
    return {
      page: ''
    }
  },
  created() {
    if (getToken()) removeToken()
  },
  methods: {
    onChildInit(value) {
      this.page = value
    },
    getActiveClass(property) {
      return this.page === property ? 'active' : ''
    }
  }
}
</script>
